import { gql, useSuspenseQuery } from '@apollo/client';
import { useMemo } from 'react';

export const BookVisitRequestLinkParamsFragment = gql`
    fragment BookVisitRequestLinkVisitRequestLink on VisitRequest {
        id
        patient {
            id
        }
        address {
            id
        }
        serviceArea {
            id
        }
    }
`;

const BOOK_VISIT_REQUEST_LINK_PARAMS_QUERY = gql`
    query BookVisitRequestLinkParams($id: UUID!) {
        visitRequest(id: $id) {
            ...BookVisitRequestLinkVisitRequestLink
        }
    }
    ${BookVisitRequestLinkParamsFragment}
`;

export interface IBookVisitRequestLinkParamsFragment {
    id: string;
    patient: {
        id: string;
    };
    address: {
        id: string;
    } | null;
    serviceArea: {
        id: string;
    } | null;
}

export function buildBookVisitRequestLink(visitRequest: IBookVisitRequestLinkParamsFragment) {
    const params = new URLSearchParams();
    params.set('patientId', visitRequest.patient.id);
    params.set('addressId', visitRequest.address?.id ?? '');
    params.set('serviceAreaId', visitRequest.serviceArea?.id ?? '');
    params.set('visitRequestId', visitRequest.id);
    return `/visits/create?${params.toString()}`;
}

export const useBookVisitRequestLink = (visitRequestId: string) => {
    const { data } = useSuspenseQuery<{
        visitRequest: IBookVisitRequestLinkParamsFragment | null;
    }>(BOOK_VISIT_REQUEST_LINK_PARAMS_QUERY, { variables: { id: visitRequestId } });

    const url = useMemo(() => {
        if (!data.visitRequest) {
            return `/visits/create?visitRequestId=${visitRequestId}`;
        }
        return buildBookVisitRequestLink(data.visitRequest);
    }, [data.visitRequest, visitRequestId]);
    return url;
};
